import React from 'react';
import "./asap-file-list.scss";
import AsapTable from '../../shared/components/asap-table/asap-table';

const AsapFileList = () => {
    return (
        <div className="ocr-list-page">
            <div className="ocr-title">
                <span className="text">COMPLETE ASAP CASES</span>
            </div>
            <AsapTable />
        </div>
    )
}

export default AsapFileList;
